/*
 * @Author: wuwei
 * @Date: 2025-10-23 08:51:20
 * @LastEditors: wuwei
 * @LastEditTime: 2026-02-25 16:07:13
 * @Description: 
 * Copyright (c) 2025-present HBIS Digital Technology Co.,Ltd. All rights reserved. 
 */
//该页面专门用于维护路由器
 
//引入vue-router
import Vrouter from 'vue-router'
 
 
//创建并暴露 路由器
export default new Vrouter({
	mode: 'history',
    routes:[
        {
            name:'首页',//命名路由,:to="{name='banji'}"
            path:'/',  //当路径是 /class时，内容区就显示ClassPage这个组件。
            component: () => import('../components/Indexnew'),
        },
		{
		    path:'/list',  //当路径是 /class时，内容区就显示ClassPage这个组件。
		    component: () => import('../components/listnew'), 
		},
		{
		    path:'/new_details',  //当路径是 /class时，内容区就显示ClassPage这个组件。
		    component: () => import('../components/new_detailsnew'), 
		},
		{
		    path:'/new_detailsold',  //当路径是 /class时，内容区就显示ClassPage这个组件。
		    component: () => import('../components/new_details'), 
		},
		{
		    path:'/quick',  //当路径是 /class时，内容区就显示ClassPage这个组件。
		    component: () => import('../components/quicknew'), 
		},
		{
		    path:'/qzss',  //当路径是 /class时，内容区就显示ClassPage这个组件。
		    component: () => import('../components/qzss'), 
		},
		{
		    path:'/sqxzjcgszl',  //当路径是 /class时，内容区就显示ClassPage这个组件。
		    component: () => import('../components/sqxzjcgszlnew'), 
		},
		
		
    ],
	scrollBehavior (to, from, savedPosition) {
	    if (savedPosition) {
	      return savedPosition
	    } else {
	      return { x: 0, y: 0 }
	    }
	}
});